import { LayoutDashboard, Search, Users, FileText, Share2, Radar, Wallet, ShieldCheck, ShieldAlert, Globe, Plane, Landmark, Home, Megaphone, UserCog, Coins, BadgeCheck, UserSearch, Bug, DatabaseZap, GraduationCap, ScanSearch, FolderOpen, Code2, BookOpen, Scale, Crosshair, Smartphone, UserCheck, UserX, ScrollText, MapPin, MapPinned, ShieldX } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { usePortal } from '../PortalAuth';

export const NAV = [
  { to: '/portal', icon: LayoutDashboard, label: 'Panoramica', id: 'dashboard', end: true, primary: true },
  { to: '/portal/ricerca', icon: Search, label: 'Ricerca aziende', id: 'search', primary: true },
  { to: '/portal/persone', icon: Users, label: 'Ricerca persone', id: 'people', primary: true },
  { to: '/portal/report', icon: FileText, label: 'Report e documenti', short: 'Report', id: 'reports', primary: true },
  { to: '/portal/dossier', icon: FolderOpen, label: 'Dossier (report aggregato)', short: 'Dossier', id: 'dossier' },
  { to: '/portal/grafo', icon: Share2, label: 'Grafo relazioni', short: 'Grafo', id: 'graph', primary: true },
  { to: '/portal/osint', icon: Globe, label: 'OSINT', id: 'osint' },
  { to: '/portal/monitoraggio', icon: Radar, label: 'Monitoraggio', id: 'monitoring' },
  { to: '/portal/immobili', icon: Home, label: 'Immobili', id: 'immobili' },
  { to: '/portal/estero', icon: Landmark, label: 'Estero', id: 'estero' },
  { to: '/portal/reputational', icon: ShieldAlert, label: 'Reputational check (AML)', short: 'Reputational', id: 'reputational', primary: true },
  { to: '/portal/persone?tab=negativita', icon: ShieldX, label: 'Negatività persone fisiche (scheda di Ricerca persone)', short: 'Negatività', id: 'negativita' },
  { to: '/portal/richieste/asset_trace', icon: Coins, label: 'Rintraccio patrimoniale', id: 'asset_trace', request: true },
  { to: '/portal/richieste/certificates', icon: BadgeCheck, label: 'Certificati', id: 'certificates', request: true },
  { to: '/portal/richieste/heirs_accept', icon: UserCheck, label: 'Rintraccio eredi con accettazione', short: 'Eredi con accettazione', id: 'heirs_accept', request: true },
  { to: '/portal/richieste/heirs_no_accept', icon: UserX, label: 'Rintraccio eredi senza accettazione', short: 'Eredi senza accettazione', id: 'heirs_no_accept', request: true },
  { to: '/portal/richieste/deceased_assets', icon: ScrollText, label: 'Rintraccio patrimoniale de cuius', short: 'Patrimonio de cuius', id: 'deceased_assets', request: true },
  { to: '/portal/richieste/residence_trace', icon: MapPin, label: 'Rintraccio residenza', id: 'residence_trace', request: true },
  { to: '/portal/richieste/residence_domicile', icon: MapPinned, label: 'Rintraccio residenza e domicilio', short: 'Residenza e domicilio', id: 'residence_domicile', request: true },
  { to: '/portal/richieste/candidate_check', icon: UserSearch, label: 'Check candidato pre-assunzione', id: 'candidate_check', request: true },
  { to: '/portal/whistleblowing', icon: Megaphone, label: 'Whistleblowing', id: 'whistleblowing' },
  { to: '/portal/travel-security', icon: Plane, label: 'Travel Security', id: 'travel' },
  { to: '/portal/richieste/travel_protection', icon: ShieldCheck, label: 'Servizi di sicurezza in viaggio', short: 'Servizi di sicurezza', id: 'travel_protection', request: true },
  { to: '/portal/cyber-security', icon: Scale, label: 'Cyber Security', short: 'Obblighi di legge', id: 'cyber_legal' },
  { to: '/portal/richieste/vapt', icon: Bug, label: 'Vulnerability Assessment e Penetration Test', short: 'VA / PT', id: 'vapt', request: true },
  { to: '/portal/richieste/data_leak', icon: DatabaseZap, label: 'Cyber Risk Investigation', id: 'data_leak', request: true },
  { to: '/portal/richieste/awareness', icon: GraduationCap, label: 'Training & Awareness', id: 'awareness', request: true },
  { to: '/portal/richieste/attack_sim', icon: Crosshair, label: 'Simulazioni di attacco', id: 'attack_sim', request: true },
  { to: '/portal/verifiche-sicurezza', icon: ScanSearch, label: 'Verifiche di sicurezza e Data Leakage', id: 'security_check' },
  { to: '/portal/richieste/mdm', icon: Smartphone, label: 'Device Management', id: 'mdm', request: true },
  { to: '/portal/api-aml', icon: Code2, label: 'Consumi API AML', short: 'API AML', id: 'api_usage' },
  { to: '/portal/plafond', icon: Wallet, label: 'Plafond', id: 'wallet' },
  { to: '/portal/utenti', icon: UserCog, label: 'Utenti e permessi', id: 'team', owner: true },
  { to: '/portal/sicurezza', icon: ShieldCheck, label: 'Impostazioni e sicurezza', id: 'security' },
  { to: '/portal/guida', icon: BookOpen, label: 'Guida e istruzioni', short: 'Guida', id: 'guide' },
];

export const AREAS = [
  { id: 'financial', label: 'Financial Risk', icon: Coins, text: 'Affidabilità di aziende e persone, patrimoni, recupero crediti e antiriciclaggio.',
    groups: [
      { label: 'Pre-fido', items: ['search', 'people', 'reports', 'dossier', 'graph', 'osint', 'reputational', 'estero', 'monitoring'] },
      { label: 'Post-fido / Contenzioso', items: ['immobili', 'asset_trace', 'heirs_accept', 'heirs_no_accept', 'deceased_assets', 'residence_trace', 'residence_domicile'] },
      { label: 'Certificati e Documenti ufficiali', items: ['certificates'] },
    ] },
  { id: 'compliance', label: 'HR & Compliance', icon: UserSearch, text: 'Verifiche sui candidati e canale whistleblowing conforme al D.Lgs. 24/2023.', items: ['candidate_check', 'whistleblowing'] },
  { id: 'security', label: 'Sicurezza', icon: Plane, text: 'Protezione delle persone in viaggio con indice di rischio e avvisi.', items: ['travel', 'travel_protection'] },
  { id: 'cyber', label: 'Cyber Security & Data Leakage', icon: Bug, text: 'Test di vulnerabilità, fughe di dati e formazione contro gli attacchi.', items: ['cyber_legal', 'vapt', 'data_leak', 'awareness', 'attack_sim', 'security_check', 'mdm'] },
  { id: 'aml_api', label: 'API AML', icon: Code2, text: 'Verifiche antiriciclaggio direttamente dai tuoi sistemi tramite API.', items: ['api_usage'] },
];
AREAS.forEach((a) => { if (a.groups) a.items = a.groups.flatMap((g) => g.items); });
export const apiOnly = (user) => { const a = areasOf(user); return a.length > 0 && a.every((x) => x === 'aml_api'); };
const FIXED = { home: ['dashboard'], account: ['wallet', 'team', 'security', 'guide'] };

export const areasOf = (user) => user?.areas_enabled || ['financial'];
const ALWAYS = ['dashboard', 'security', 'guide'];
export const PERMISSION_SECTIONS = NAV.filter((n) => !ALWAYS.includes(n.id) && !n.owner);

export const canSee = (user, id) => {
  const item = NAV.find((n) => n.id === id);
  if (!user || !item) return true;
  const inArea = AREAS.filter((a) => a.items.includes(id));
  if (inArea.length && !inArea.some((a) => areasOf(user).includes(a.id))) return false;
  if (user.is_owner !== false) return true;
  if (item.owner) return false;
  return ALWAYS.includes(id) || (user.permissions?.sections || []).includes(id);
};

export const sectionOf = (pathname) => [...NAV].filter((n) => n.to !== '/portal').sort((a, b) => b.to.length - a.to.length).find((n) => pathname.startsWith(n.to))?.id;

export function useNav() {
  const { user } = usePortal();
  return NAV.filter((n) => canSee(user, n.id));
}

export function useSideCollapsed() {
  const [c, setC] = useState(() => localStorage.getItem('bond_side_collapsed') === '1');
  const toggle = () => setC((v) => { localStorage.setItem('bond_side_collapsed', v ? '0' : '1'); return !v; });
  return [c, toggle];
}

export function useActiveIntoView() {
  const { pathname } = useLocation();
  const ref = useRef(null);
  useEffect(() => { ref.current?.querySelector('a.active')?.scrollIntoView({ block: 'nearest' }); }, [pathname]);
  return ref;
}

export function useNavAreas() {
  const { user } = usePortal();
  const seen = new Set();
  const split = (a) => (a.groups ? a.groups.map((g, i) => ({ id: `${a.id}-${i}`, label: i === 0 ? a.label : '', sub: g.label, items: g.items })) : [a]);
  const groups = [{ id: 'home', label: '', items: FIXED.home }, ...AREAS.filter((a) => areasOf(user).includes(a.id)).flatMap(split), { id: 'account', label: 'Account', items: FIXED.account }];
  return groups.map((a) => ({
    id: a.id, label: a.label, sub: a.sub,
    items: a.items.filter((id) => canSee(user, id)).map((id) => {
      const item = NAV.find((n) => n.id === id);
      const testid = seen.has(id) ? `${id}-${a.id}` : id;
      seen.add(id);
      return { ...item, testid, key: `${a.id}-${id}`, locked: (user?.services_disabled || []).includes(id) };
    }),
  })).filter((a) => a.items.length);
}

export const LOGO = '/assets/BOND_wordmark_gold.png';

export const initials = (u) => (u.name || u.email || '?').split(/[\s@.]+/).filter(Boolean).slice(0, 2).map((s) => s[0].toUpperCase()).join('');
